import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import defaultImage from "../../Assets/image 880.png";
import { useNavigate } from "react-router-dom";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { trackEvent } from "../Utility/Utility";
import { encryptURLParam } from "../../Common/Axios/encrypt";

const ShopByCategoryOptimized = () => {
  const navigate = useNavigate();
  const [finalData, setFinalData] = useState([]);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const translation = getTranslationData();
  const categoryAllData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData
  );
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (categoryAllData) {
      const displayData = categoryAllData
        .filter((category) => category?.displayHeader === false)
        .sort((a, b) => a.displayOrder - b.displayOrder);
      setFinalData(displayData);
    }
  }, [categoryAllData]);

  const handleImageClick = (item) => {
    // Conditionally encrypt the categoryId parameter based on environment setting
    const categoryId = item?.name;
    const finalCategoryId = process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false'
      ? categoryId
      : encryptURLParam(categoryId);

    const fullUrl = `${window.location.origin
      }/productlist?categoryId=${finalCategoryId}`;
    trackEvent("category_viewed", {
      title: item?.name,
      page_url: fullUrl,
      section_title: `${translation?.shopByCategory}`,

    });
    navigate(`/productlist?categoryId=${finalCategoryId}`, {
      state: { item },
    });
  };

  const handleScrollRight = () => {
    scrollContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };

  const handleScrollLeft = () => {
    scrollContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  return (
    <>
      {finalData.length ? (
        <section className="py-xl-2 earn bg">
          <div className="container">
            <div className="flex items-center justify-between">
              <h5 className="sec-below-head">{translation?.shopByCategory}</h5>

              {Array.isArray(finalData) &&
                finalData.length > 7 &&
                !isMobileView && (
                  <div className="scroll-buttons-group">
                    <button
                      className="scroll-button1"
                      onClick={handleScrollLeft}
                    >
                      <i className="fa-solid fa-chevron-left"></i>
                    </button>
                    <button
                      className="scroll-button1"
                      onClick={handleScrollRight}
                    >
                      <i className="fa-solid fa-chevron-right"></i>
                    </button>
                  </div>
                )}
            </div>

            <div className="relative category-scroll-wrapper">
              <div
                className="scrollbar-hide explore-section"
                ref={scrollContainerRef}
              >
                {finalData.map((item, index) => (
                  <div
                    key={index}
                    className={`custom-img-bg ${isMobileView ? "mobile" : ""}`}
                  >
                    <div className="relative flex items-center justify-center cust-product">
                      <img
                        onClick={() => handleImageClick(item)}
                        style={{ cursor: "pointer" }}
                        className="cat-img"
                        alt={item?.name}
                        src={
                          item.image === "false"
                            ? defaultImage
                            : isMobileView
                              ? `${process.env.REACT_APP_CLIENT_URL}${item?.mobileImage}`
                              : `${process.env.REACT_APP_CLIENT_URL}${item?.image}`
                        }
                      />
                    </div>
                    <span className="mt-2 cat-name cat-shop">{item?.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default ShopByCategoryOptimized;
